var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-sidebar" }, [
    _c(
      "div",
      { staticClass: "menu-sidebar--main" },
      [
        _c(
          "a",
          {
            staticClass: "u-reset menu-sidebar--link",
            attrs: { href: _vm.mapLink }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("translate")("HOME_OVERLAY.CTA_LABEL")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("snake-pattern", { staticClass: "menu-sidebar--snake-pattern" }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "u-reset menu-sidebar--link",
            attrs: { href: _vm.activeRootCategory.url }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("translate")("HOME_OVERLAY.SECONDARY_ACTION_LABEL")
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("snake-pattern", { staticClass: "menu-sidebar--snake-pattern" }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "u-reset menu-sidebar--link",
            attrs: { href: _vm.translate("CMS.USAGE.URL") }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("translate")("CMS.USAGE.TITLE")) +
                "\n        "
            )
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "menu-sidebar--footer" }, [
      _c("div", { staticClass: "menu-sidebar--footer-items" }, [
        _c("div", { staticClass: "menu-sidebar--footer-item" }, [
          _c(
            "a",
            {
              staticClass:
                "u-reset menu-sidebar--link menu-sidebar--link__footer",
              attrs: { href: _vm.translate("CMS.IMPRINT.URL") }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm._f("translate")("CMS.IMPRINT.TITLE")) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "menu-sidebar--footer-item" }, [
          _c(
            "a",
            {
              staticClass:
                "u-reset menu-sidebar--link menu-sidebar--link__footer",
              attrs: {
                href: _vm.translate("MENU_SIDEBAR.FOOTER.BUX_APP.URL"),
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._f("translate")("MENU_SIDEBAR.FOOTER.BUX_APP.TITLE")
                  ) +
                  "\n                "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6b8296", { render: render, staticRenderFns: staticRenderFns })
  }
}